/*=============================================== MarkdownContainerPage ===============================================*/

import { Link } from "react-router-dom"
import { MarkdownContainer } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

const MarkdownContainerPage = () => {
    const post: string =
        "## Hello world \n\n I'm some markdown content **compiled** to *jsx*"

    const items: ItemType[] = [
        {
            content: <MarkdownContainer>{post}</MarkdownContainer>,
            code: 'const post = "## Hello world\\n\\nI\'m some markdown content **compiled** to *jsx*"\n\n<MarkdownContainer>{post}</MarkdownContainer>',
            codeTs: 'const post: string = "## Hello world\\n\\nI\'m some markdown content **compiled** to *jsx*"\n\n<MarkdownContainer>{post}</MarkdownContainer>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "options",
            type: "object",
            default: (
                <>
                    See the base options{" "}
                    <Link to="/helpers/options-markdown">here</Link>.
                </>
            ),
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default MarkdownContainerPage
